import src from '/Users/huynhducduy/workspace/innosearch/innosearch-fe/interface/src/assets/flight/flight-background.png?url';

export default {
  lqip: `data:image/png;base64,UklGRpoAAABXRUJQVlA4WAoAAAAQAAAAHwAACwAAQUxQSAoAAAABB9D9iAhERP8DVlA4IGoAAAAwBACdASogAAwAPm00k0akIyGhMAgAgA2JQBOmUGMAHKbKPNZzFhpQ/NAA/un9KyqjEQy2Q7KWuhkK/Xy2GDc+L/x5nP+HCEOrp+8McQmeeUNIMuDA1onzOoXFI3WxIbKoChGMZkaK/zAA`,
  src,
  width: 1440,
  height: 540,
};
			